import { Component, ReactNode, ErrorInfo } from "react";
import { CrashFallbackProviders } from "../CrashFallbackProviders/CrashFallbackProviders";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export class CrashErrorBoundary extends Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Application crashed:", error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  public render() {
    if (this.state.hasError) {
      return <CrashFallbackProviders error={this.state.error!} errorInfo={this.state.errorInfo} />;
    }

    return this.props.children;
  }
}
